import { createHerdIcon } from 'app/agriculture/hooks/useMapRender/mapRenderUtils';
import { SelectionSubType } from 'app/shared/selection/SelectionType';
import { PickId } from 'app/agriculture/FarmMain/MapRenderer/types/PickId';
import { convertGeometryToMapLocation } from 'app/agriculture/components/utils/convertGeometryToLocation/convertGeometryToMapLocation';
import { Herd } from 'app/agriculture/queries/herds/types/Herd';
import { Position } from 'app/agriculture/queries/types/geometry/Position';
import { HerdSnapshot } from 'app/agriculture/queries/herds/types/HerdSnapshot';

export function isHerdPressed(viewer: Cesium.Viewer, position: Cesium.Cartesian2, herdId?: string) {
    const picks = viewer.scene.drillPick(position);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const herdPick = picks
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        .filter((pick) => !!pick.id?.getId)
        .find(
            (pick: { id?: PickId }) =>
                pick.id?.getId() == herdId && pick.id?.selectionSubType == SelectionSubType.HERD,
        );

    return herdPick != null;
}

export function makeDraggableMarker(
    herd?: Herd & { location: Position | null; snapshot: HerdSnapshot | null },
) {
    if (herd?.location == null) return undefined;
    return createHerdIcon(
        {
            id: herd.id,
            location: convertGeometryToMapLocation({
                type: 'Point',
                coordinates: herd.location,
            }),
            isSelected: true,
        },
        {
            herdType: herd.herdType,
            animalSpecies: herd.animalSpecies,
            totalAnimals: herd.snapshot?.totalAnimals ?? 0,
            isMoveIcon: true,
        },
    );
}
